import * as React from "react"
import * as _ from "lodash"
import {connect} from "react-redux"
import {IAppState} from "../../models/IAppState";
import {AccessConfig, DoctorAccessConfig, NurseAccessConfig} from "../../routes";
import {IRoute} from "express";
import IDoctorProfile from "../../models/IDoctorProfile";

export interface AccessControlProps {
    onSuccess: any;
    route: any;
    doctorProfile: IDoctorProfile;
}

export interface AccessControlState {
    isAllowed: boolean
}

class AccessControlComponent extends React.Component<AccessControlProps, AccessControlState> {
    isAllowed(config: AccessConfig) {
        let path = this.props.route.path || "/";
        let isAllowed = false;
        if ( path === "/") {
            if (config.hasAccess) isAllowed = true;
        } else {
            let urlParams: string[] = path.split("/").filter((item: string) => { return item.indexOf(":") !== 0 && item !== "" });
            let currObject: AccessConfig = config;
            let iterator: number;
            for ( iterator = 0; iterator < urlParams.length; iterator++ ) {
                currObject = currObject.childrenMap[urlParams[iterator]];
                if (!currObject.hasAccess) {
                    break;
                }
            }
            if ( iterator === urlParams.length ) {
                isAllowed = true;
            }
        }
        return isAllowed;
    }

    checkAccess() {
        if (this.props.doctorProfile !== null) {
            return this.isAllowed(DoctorAccessConfig);
        } else {
            return this.isAllowed(NurseAccessConfig);
        }
    }

    render() {
        let isAllowed = this.checkAccess();
        let Component = this.props.route.onSuccess;
        if (isAllowed) {
            return (
                <Component { ...this.props } />
            )
        } else {
            return (
                <div style={{textAlign: "center", paddingTop: "50px"}}><h1>You are not authorized to view this page</h1></div>
            )
        }
    }

}

const mapStateToProps = (state: IAppState): any => {
    let {doctorProfile} = state;
    return {doctorProfile};
}

const mapDispatchToProps = () => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AccessControlComponent);